import styled from '@emotion/styled';
import { colors } from 'theme/colors';

export const ModalContent = styled('div')({
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  backgroundColor: colors.white,
  borderRadius: '4px',
  border: `1px solid ${colors.primary500}`,
  padding: '32px',
  margin: '16px',
  width: '100%',
  maxWidth: '1200px',
  maxHeight: '90vh',
  overflowY: 'auto',
  boxShadow: '0px 7px 14px 0px #053A6812, 0px 7px 7px 0px #053A6826',

  '@media (min-width: 600px)': {
    margin: 'auto',
  },

  '&::-webkit-scrollbar': {
    width: '12px',
    borderRight: '4px solid transparent',
    backgroundClip: 'padding-box',
  },
  '&::-webkit-scrollbar-track': {
    backgroundColor: colors.primary50,
    borderRadius: '4px',
    marginTop: '4px',
    marginBottom: '4px',
    borderRight: '4px solid transparent',
    backgroundClip: 'padding-box',
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: colors.primary400,
    borderRadius: '4px',
    border: `2px solid ${colors.primary50}`,
    borderRight: '4px solid transparent',
    backgroundClip: 'padding-box',
  },
  '&::-webkit-scrollbar-thumb:hover': {
    backgroundColor: colors.primary400,
  },
  '&::-webkit-scrollbar-button': {
    display: 'none',
  },
});

export const ModalHeader = styled('div')({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginBottom: '32px',
});

export const ModalBody = styled('div')({
  flex: 1,
});

export const ModalFooter = styled('div')({
  display: 'flex',
  justifyContent: 'flex-end',
  alignItems: 'center',
  marginTop: '32px',
});

export const TableWrapper = styled('div')({
  marginTop: '20px',
  borderRadius: '4px',
  overflow: 'hidden',
});

export const ComparisonTable = styled('table')({
  width: '100%',
  borderCollapse: 'separate',
  borderSpacing: 0,
  tableLayout: 'fixed',
});

export const FirstColumn = styled('col')({
  width: '200px',
});

export const ValueColumn = styled('col')({
  width: 'calc((100% - 200px) / 2)',
});

export const EmptyHeaderCell = styled('th')({
  backgroundColor: colors.white,
  padding: '4px 16px',
  textAlign: 'right',
  border: 'none',
  fontWeight: 600,
  fontSize: '14px',
  lineHeight: '24px',
});

export const BeforeHeaderCell = styled('th')({
  backgroundColor: colors.primary50,
  padding: '4px 16px',
  textAlign: 'center',
  border: `1px solid ${colors.primary50}`,
  borderRight: `1px solid ${colors.white}`,
  fontWeight: 600,
  fontSize: '14px',
  lineHeight: '24px',
  color: colors.primary900,
  borderTopLeftRadius: '4px',
});

export const AfterHeaderCell = styled('th')({
  backgroundColor: colors.primary50,
  padding: '4px 16px',
  textAlign: 'center',
  borderTop: `1px solid ${colors.primary50}`,
  borderBottom: `1px solid ${colors.primary50}`,
  borderRight: `1px solid ${colors.primary50}`,
  fontWeight: 600,
  fontSize: '14px',
  lineHeight: '24px',
  color: colors.primary900,
});

export const StateChipsContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
  alignItems: 'center',
});

export const ValuesListContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  gap: '4px',
});

export const LinkedValueWrapper = styled('div')({
  fontWeight: 400,
});

export const CategoryHeaderFirstCell = styled('td')({
  backgroundColor: colors.primary25,
  padding: '4px 16px',
  fontWeight: 600,
  fontSize: '14px',
  borderRight: `1px solid ${colors.primary50}`,
  borderLeft: `1px solid ${colors.primary50}`,
  textAlign: 'right',
  verticalAlign: 'middle',
  width: '200px',
  maxWidth: '200px',
  lineHeight: '24px',
});

export const CategoryHeaderNoChangesCell = styled('td')({
  backgroundColor: colors.primary25,
  padding: '4px 16px',
  fontSize: '14px',
  fontStyle: 'italic',
  color: colors.gray900,
  textAlign: 'center',
  lineHeight: '24px',
});

export const CategoryHeaderEmptyCell = styled('td')({
  backgroundColor: colors.primary25,
  padding: '4px 16px',
  lineHeight: '24px',
});

export const DataRowFirstCell = styled('td')({
  backgroundColor: colors.primary15,
  padding: '4px 16px',
  borderRight: `1px solid ${colors.primary50}`,
  borderLeft: `1px solid ${colors.primary50}`,
  fontSize: '14px',
  fontWeight: 500,
  textAlign: 'right',
  verticalAlign: 'middle',
  lineHeight: '24px',
});

export const DataRowValueCell = styled('td')({
  padding: '4px 16px',
  fontSize: '14px',
  textAlign: 'center',
  wordWrap: 'break-word',
  whiteSpace: 'normal',
  verticalAlign: 'top',
  lineHeight: '24px',
});

export const InfoGridContainer = styled('div')({
  backgroundColor: colors.gray100,
  border: `1px solid ${colors.gray200}`,
  height: '84px',
  borderRadius: '4px',
  marginBottom: '24px',
});

export const InfoGridItem = styled('div')({
  padding: '16px',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
});

export const InfoLabel = styled('div')({
  marginBottom: '4px',
  fontSize: '12px',
  fontWeight: 600,
});

export const InfoValue = styled('div')({
  fontSize: '14px',
});
